export class ImosToggleList extends HTMLElement {
  private items: HTMLElement[] = [];
  private toggle: HTMLButtonElement | null = null;
  private expanded = false;

  connectedCallback(): void {
    this.items = Array.from(this.children).filter(
      (el): el is HTMLElement => el instanceof HTMLElement,
    );

    const visibleCount = Math.max(
      1,
      Number.parseInt(this.getAttribute('visible-count') ?? '1', 10) || 1,
    );

    if (this.items.length <= visibleCount) {
      return;
    }

    for (const item of this.items.slice(visibleCount)) {
      item.hidden = true;
    }

    const hiddenCount = this.items.length - visibleCount;
    const showMore = (this.getAttribute('show-more-text') ?? 'Show %s more').replace(
      '%s',
      String(hiddenCount),
    );
    const showLess = this.getAttribute('show-less-text') ?? 'Show less';

    this.toggle = document.createElement('button');
    this.toggle.type = 'button';
    this.toggle.className = this.getAttribute('link-class') ?? 'toggle-link';
    this.toggle.textContent = showMore;
    this.toggle.addEventListener('click', (event) => {
      event.preventDefault();
      this.expanded = !this.expanded;
      for (const item of this.items.slice(visibleCount)) {
        item.hidden = !this.expanded;
      }
      if (this.toggle) {
        this.toggle.textContent = this.expanded ? showLess : showMore;
      }
    });

    this.appendChild(this.toggle);
  }
}

customElements.define('imos-toggle-list', ImosToggleList);
